export default "dist/images/components-columns-width-control-4-2-grid.5103a98.png";